import { useIntl } from 'umi';
import { Modal, notification } from 'tea-component';
import { deleteVideo } from '../services';
import { isMockUUID } from '../utils';

import type { IFilter, IVideo } from '../types';

export default function useDeleteVideoEffect(props: {
  videos: IVideo[];
  setVideos: React.Dispatch<React.SetStateAction<IVideo[]>>;
}) {
  const { videos, setVideos } = props;

  const { formatMessage } = useIntl();

  const notificationSuccess = () => {
    notification.success({
      description: formatMessage({ id: 'aigc_common_delete_success' }),
      // className: 'filter-lock-alert',
      duration: 3000,
    });
  };

  const notificationFail = () => {
    notification.error({
      description: formatMessage({ id: 'aigc_common_delete_fail' }),
      // className: 'filter-lock-alert',
      duration: 3000,
    });
  };

  const updateVideosState = (video: IVideo) => {
    const targetVideoIdx = videos?.findIndex((videoItem) => videoItem?.uuid === video?.uuid);
    if (targetVideoIdx === -1) return;
    const videosTmp = [...videos?.slice(0, targetVideoIdx), ...videos?.slice(targetVideoIdx + 1)];
    setVideos(videosTmp);
  };

  const handleDeleteClient = (video: IVideo) => {
    updateVideosState(video);
    notificationSuccess();
  };

  const handleDeleteServer = async (video: IVideo, filter: IFilter) => {
    try {
      await deleteVideo({
        role_model_type: filter?.role_model_type,
        uuid: video?.uuid,
      });

      updateVideosState(video);

      notificationSuccess();
    } catch (exception) {
      notificationFail();
    }
  };

  const handleDelete = async (video: IVideo, filter: IFilter) => {
    const flag = await Modal.confirm({
      message: formatMessage({ id: 'aigc_common_delete' }),
      description: formatMessage({ id: 'dba_motion_capture_delete_tips' }, { name: video?.origin_video_name }),
      okText: formatMessage({ id: 'aigc_common_confirm' }),
      cancelText: formatMessage({ id: 'aigc_common_cancel' }),
    });
    if (!flag) return;

    if (isMockUUID(video?.uuid)) {
      handleDeleteClient(video);
      return;
    }

    handleDeleteServer(video, filter);
  };

  return {
    onDelete: handleDelete,
  };
}
